module.exports = __webpack_public_path__ + "static/media/google.42e92628.svg";